
export function dealWithSpecialValue(val) {
    switch (val) {
      case '-':
      case null:
      case undefined:
      case '':
      case '/':
        return '-'
      default:
        return val
    }
  }
  